export const STATUS = {
  OPEN: {
    ID: 1,
    NAME: 'OPEN'
  },
  ARCHIVED: {
    ID: 2,
    NAME: 'ARCHIVED'
  },
  PUBLISHED: {
    ID: 3,
    NAME: 'PUBLISHED'
  }
};

export const ROLE = {
  PRIMARY: 'Primary',
  ADMIN: 'Admin',
  BOARD: 'Board',
  EXEC: 'Executive',
  MANAGER: 'Manager'
};

export const FORM_TYPE = {
  DISTRICT_OLD: {
    ID: 1,
    NAME: 'Region / Estimating / Corporate',
    SHORT: 'Office',
    ACTIVE: false
  },
  OPERATIONS_OLD: {
    ID: 2,
    NAME: 'Operations - Old',
    SHORT: 'Ops - Old',
    ACTIVE: false
  },
  SERVICES_OPS_OLD: {
    ID: 3,
    NAME: 'Services Operations - Old',
    SHORT: 'S. Ops - Old',
    ACTIVE: false
  },
  SERVICES_STAFF_OLD: {
    ID: 4,
    NAME: 'Services Staff - Old',
    SHORT: 'S. Staff - Old',
    ACTIVE: false
  },
  LEGAL_OLD: {
    ID: 5,
    NAME: 'Corp Legal - Old',
    SHORT: 'Legal - Old',
    ACTIVE: false
  },
  TECHNOLOGY_OLD: {
    ID: 6,
    NAME: 'Technology',
    SHORT: 'Tech',
    ACTIVE: false
  },
  CRAFT: {
    ID: 7,
    NAME: 'Craft',
    SHORT: 'Craft',
    ACTIVE: true
  },
  FOREMAN_OLD: {
    ID: 8,
    NAME: 'GF/Foreman - Old',
    SHORT: 'GF/F - Old',
    ACTIVE: false
  },
  INTERN_OLD: {
    ID: 9,
    NAME: 'Intern',
    SHORT: 'Intern',
    ACTIVE: false
  },
  STOCKHOLDERS_OLD: {
    ID: 10,
    NAME: 'Stockholders - Old',
    SHORT: 'Stock - Old',
    ACTIVE: false
  },
  SERVICES_TECH: {
    ID: 11,
    NAME: 'Services Technician',
    SHORT: 'S. Tech',
    ACTIVE: true
  },
  TALENT_ACQUISITION_OLD: {
    ID: 12,
    NAME: 'Talent Acquisition - Old',
    SHORT: 'Talent Acq. - Old',
    ACTIVE: false
  },
  HUMAN_RESOURCES_OLD: {
    ID: 13,
    NAME: 'Human Resources - Old',
    SHORT: 'HR - Old',
    ACTIVE: false
  },
  ADMIN_ASST_OLD: {
    ID: 14,
    NAME: 'Administrative Assistant - Old',
    SHORT: 'Admin Asst - Old',
    ACTIVE: false
  },
  TECHNOLOGY_LEADERS_OLD: {
    ID: 15,
    NAME: 'Technology Leaders',
    SHORT: 'Tech Leaders',
    ACTIVE: false
  },
  TECHNOLOGY_OLD_2: {
    ID: 16,
    NAME: 'Technology',
    SHORT: 'Tech',
    ACTIVE: false
  },
  ADMIN_ASST: {
    ID: 17,
    NAME: 'Administrative Assistant',
    SHORT: 'Admin Asst',
    ACTIVE: true
  },
  BETA_DISTRICT: {
    ID: 18,
    NAME: 'Beta - Corporate Pilot Group',
    SHORT: 'Beta - Office',
    ACTIVE: false
  },
  LEGAL: {
    ID: 19,
    NAME: 'Corp Legal',
    SHORT: 'Legal',
    ACTIVE: true
  },
  OPERATIONS: {
    ID: 20,
    NAME: 'Operations',
    SHORT: 'Ops',
    ACTIVE: true
  },
  SERVICES_OPS: {
    ID: 21,
    NAME: 'Services Operations',
    SHORT: 'S. Ops',
    ACTIVE: true
  },
  SERVICES_STAFF: {
    ID: 22,
    NAME: 'Services Staff',
    SHORT: 'S. Staff',
    ACTIVE: true
  },
  BETA_TECHNOLOGY: {
    ID: 23,
    NAME: 'Beta - Technology Old',
    SHORT: 'Beta - Tech',
    ACTIVE: false
  },
  BETA_TECHNOLOGY_LEADERS: {
    ID: 24,
    NAME: 'Beta - Technology Leaders Old',
    SHORT: 'Beta - Tech Leaders',
    ACTIVE: false
  },
  BETA_HUMAN_RESOURCES: {
    ID: 25,
    NAME: 'Beta - Corporate HR',
    SHORT: 'Beta - HR',
    ACTIVE: false
  },
  TECHNOLOGY_OLD_3: {
    ID: 26,
    NAME: 'Technology',
    SHORT: 'Tech',
    ACTIVE: false
  },
  TECHNOLOGY_LEADERS_OLD_2: {
    ID: 27,
    NAME: 'Technology Leaders',
    SHORT: 'Tech Leaders',
    ACTIVE: false
  },
  GF_FOREMAN: {
    ID: 28,
    NAME: 'General Foreman/Foreman',
    SHORT: 'GF/Foreman',
    ACTIVE: true
  },
  HUMAN_RESOURCES: {
    ID: 29,
    NAME: 'Human Resources',
    SHORT: 'HR',
    ACTIVE: true
  },
  DISTRICT: {
    ID: 30,
    NAME: 'Region / Estimating / Corporate',
    SHORT: 'Office',
    ACTIVE: true
  },
  STOCKHOLDERS: {
    ID: 31,
    NAME: 'Stockholders',
    SHORT: 'Stock',
    ACTIVE: true
  },
  TALENT_ACQUISITION: {
    ID: 32,
    NAME: 'Talent Acquisition',
    SHORT: 'Talent Acq.',
    ACTIVE: true
  },
  INTERN: {
    ID: 33,
    NAME: 'Intern',
    SHORT: 'Intern',
    ACTIVE: true
  },
  TECHNOLOGY: {
    ID: 34,
    NAME: 'Technology',
    SHORT: 'Tech',
    ACTIVE: true
  },
  TECHNOLOGY_LEADERS: {
    ID: 35,
    NAME: 'Technology Leaders',
    SHORT: 'Tech Leaders',
    ACTIVE: true
  },
};

export const MODAL = {
  SUBMIT: 'SUBMIT',
  ARCHIVE: 'ARCHIVE',
  CANCEL: 'CANCEL',
  EVAL: 'EVAL',
  GOAL: 'GOAL',
  DISCARD: 'DISCARD',
  DELETE: 'DELETE',
  ERROR: 'ERROR',
  UNSHARE: 'UNSHARE',
  CALENDAR: 'CALENDAR'
};

export const ACTION = {
  SAVE: 'SAVE',
  SEND: 'SEND',
  ARCHIVE: 'ARCHIVE',
  ARCHIVE_DOCUMENT: 'ARCHIVE_DOCUMENT',
  PUBLISH: 'PUBLISH',
  DELETE: 'DELETE',
  SHARE: 'SHARE',
  UNSHARE: 'UNSHARE'
};

export const NAVBAR_ACTION = {
  NEWEVAL: 'New Evaluation',
  EVALDASH: 'Evaluations Dashboard',
  EVALPAGE: 'Evaluation Page',
  GOALDASH: 'Goals Dashboard',
  GOALPAGE: 'New Goal Page',
  NEWGOAL: 'New Goal',
  LOGOUT: 'Logout',
  REPORTS: 'Reports'
};

export const DASHBOARD_VIEWS = {
  ACTIVE: {
    SHORT: 'Active',
    LONG: 'Active Performance Evaluations'
  },
  ARCHIVED: {
    SHORT: 'Archived',
    LONG: 'Archived Performance Evaluations'
  },
  ADMIN: {
    SHORT: 'Administrator',
    LONG: 'Administrator View (Evaluations)'
  },
  BOARD: {
    SHORT: 'Board',
    LONG: 'Board View (Evaluations)'
  },
  EXEC: {
    SHORT: 'Executive',
    LONG: 'Executive View (Evaluations)'
  },
  MANAGER: {
    SHORT: 'Manager',
    LONG: 'Manager View (Evaluations)'
  }
};

export const GOAL_DASH_VIEWS = {
  MY_GOALS: 'My Goals',
  SHARED_GOALS: 'Shared Goals',
  BOARD_VIEW: 'Board View',
  EXECUTIVE_VIEW: 'Executive View',
  MANAGER_VIEW: 'Manager View'
};

export const GOAL_STATUS = {
  NOT_STARTED: { ID: 1, NAME: 'Not Started' },
  IN_PROGRESS: { ID: 2, NAME: 'In Progress' },
  ON_HOLD: { ID: 5, NAME: 'On Hold' },
  COMPLETED: { ID: 4, NAME: 'Completed' },
  CANCELLED: { ID: 3, NAME: 'Cancelled' }
};

export const GOAL_TRACK = {
  NO_FLAG_SET: { ID: 4, NAME: 'No Flag Set' },
  ON_TRACK: { ID: 1, NAME: 'On Track' },
  OFF_TRACK: { ID: 3, NAME: 'Off Track' },
  AT_RISK: { ID: 2, NAME: 'At Risk' }
};

export const GOAL_CATEGORY = {
  NONE: { ID: 9, NAME: 'Select a Category' },
  IMPROVED_PERFORMANCE: { ID: 1, NAME: 'Improved Performance' },
  PROJECT_DEPARTMENT: { ID: 2, NAME: 'Project/Department' },
  PERSONAL_DEVELOPMENT: { ID: 3, NAME: 'Personal Development' },
  PERSONNEL_MGMT: { ID: 4, NAME: 'Personnel Mgmt' },
  ONE_YEAR_OBJECTIVE: { ID: 5, NAME: '1 Year Career Objective' },
  FIVE_YEAR_OBJECTIVE: { ID: 6, NAME: '5 Year Career Objective' },
  TEN_YEAR_OBJECTIVE: { ID: 7, NAME: '10 Year Career Objective' },
  OTHER: { ID: 8, NAME: 'Other' }
};

export const NO_COMPETENCY = { NONE: { ID: 1, NAME: 'Select a Competency' } };

export const FOUNDATIONAL_GOAL_COMPETENCY = {
  ACCOUNTABILITY_OWNERSHIP: { ID: 2, NAME: 'Accountability/Ownership' },
  ADAPTABILITY: { ID: 3, NAME: 'Adaptability' },
  COMMUNICATES_EFFECTIVELY: { ID: 4, NAME: 'Communicates Effectively' },
  INITIATIVE: { ID: 5, NAME: 'Initiative' },
  INTEGRITY: { ID: 6, NAME: 'Integrity' },
  KNOWLEDGE_COMPETENCE: {
    ID: 7,
    NAME: 'Job Knowledge/Technical Competence'
  },
  TEAMWORK_COLLAB: { ID: 8, NAME: 'Teamwork and Collaboration' }
};

export const MID_MGMT_GOAL_COMPETENCY = {
  RELATIONSHIP_COLLAB: {
    ID: 9,
    NAME: 'Mid - Builds Collaborative Relationships'
  },
  COACH_DEVELOP: { ID: 10, NAME: 'Mid - Coaches and Develops Others' },
  DECISION_MAKING: { ID: 11, NAME: 'Mid - Decision Making' },
  EXECUTES_PLAN: { ID: 12, NAME: 'Mid - Executes a Plan' },
  LEADS_TEAM: { ID: 13, NAME: 'Mid - Leads the Team' }
};

export const UPPER_MGMT_GOAL_COMPETENCY = {
  RELATIONSHIPS_NETWORKS: {
    ID: 14,
    NAME: 'Upper - Cultivates Relationships and Networks'
  },
  DELIVERS_EXECUTES: { ID: 15, NAME: 'Upper - Delivers Results/Executes' },
  DELIVERS_TALENT: { ID: 16, NAME: 'Upper - Develops Talent' },
  EMOTIONAL_INTELLIGENCE: { ID: 17, NAME: 'Upper - Emotional Intelligence' },
  MOTIVATES_EMPOWERS: {
    ID: 18,
    NAME: 'Upper - Motivates and Empowers the Team'
  }
};

export const EXECUTIVE_GOAL_COMPETENCY = {
  HP_AMBASSADOR: {
    ID: 19,
    NAME: 'Exec - Ambassador of the Hensel Phelps Culture'
  },
  BUSINESS_ACUMEN: { ID: 20, NAME: 'Exec - Demonstrates Business Acumen' },
  ENTERPRISE_MINDSET: { ID: 21, NAME: 'Exec - Enterprise-first Mindset' },
  INSPIRATION_LEADERSHIP: { ID: 22, NAME: 'Exec - Inspirational Leadership' },
  MANAGE_COMPLEXITY: { ID: 23, NAME: 'Exec - Manages Complexity' }
};

export const allCompetenciesToDisplay = (showNone = false) => {
  if (showNone) {
    return NO_COMPETENCY.NONE.NAME;
  } else {
    return {
      ...NO_COMPETENCY,
      ...FOUNDATIONAL_GOAL_COMPETENCY,
      ...MID_MGMT_GOAL_COMPETENCY,
      ...UPPER_MGMT_GOAL_COMPETENCY,
      ...EXECUTIVE_GOAL_COMPETENCY
    };
  }
};

export const COMPETENCY_URL = {
  FOUND: 'https://hpcc2013.sharepoint.com/sites/FoundationalCompetencies',
  MID: 'https://hpcc2013.sharepoint.com/sites/MidLevelCompetencies',
  UPPER: 'https://hpcc2013.sharepoint.com/sites/UpperLevelCompetencies',
  EXEC: 'https://hpcc2013.sharepoint.com/sites/ExecutiveCompetencies',
  ALL:
    'https://hpcc2013.sharepoint.com/sites/LeadershipCompetencies?&OR=Teams-HL&CT=1731358646996&clickparams=eyJBcHBOYW1lIjoiVGVhbXMtRGVza3RvcCIsIkFwcFZlcnNpb24iOiI0OS8yNDEwMDMyNDkxNiIsIkhhc0ZlZGVyYXRlZFVzZXIiOmZhbHNlfQ%3D%3D'
};

export const COMPETENCY_URL_BY_LEVEL = {
  Found: COMPETENCY_URL.FOUND,
  Mid: COMPETENCY_URL.MID,
  Upper: COMPETENCY_URL.UPPER,
  Exec: COMPETENCY_URL.EXEC
};

// Competency levels that have their own question set in the form JSON.
// Anything else -- including new codes from the ODS sync (Craft, Intern,
// CraftLdr, ...) -- uses the Foundational question set.
const NON_FOUNDATIONAL_COMPETENCIES = {
  mid: 'Mid',
  upper: 'Upper',
  exec: 'Exec'
};

export const normalizeCompetency = competencyLevel => {
  const key = String(competencyLevel || '')
    .trim()
    .toLowerCase();
  return NON_FOUNDATIONAL_COMPETENCIES[key] || 'Found';
};

export const getCompetencyUrl = competencyLevel =>
  COMPETENCY_URL_BY_LEVEL[normalizeCompetency(competencyLevel)];

export const MAX_COMMENT_CHARS = 10000;

export const NEXT_EVAL_DATE_QUESTION_TEXT = 'Next Evaluation Date';
